import textureDataLeaderBoard from '~/assets/resource/leader-board.json';
import textureDataLogoCLB from '~/assets/resource/logo-clb.json';
import textureDataVoltaBannerDesktop from '~/assets/resource/volta-banner-desktop.json';
import textureDataVoltaBanner from '~/assets/resource/volta-banner.json';
import textureDataVoltaMiniGame from '~/assets/resource/volta-mini-game-sheet.json';
import leaderBoard from '~/assets/sprites/leader-board.png';
import logoCLB from '~/assets/sprites/logo-clb.png';
import voltaBannerDesktop from '~/assets/sprites/volta-banner-desktop.png';
import voltaBanner from '~/assets/sprites/volta-banner.png';
import voltaMiniGame from '~/assets/sprites/volta-mini-game-sheet.png';
export const SpritesSheet = {
    voltaBanner: {
        image: voltaBanner,
        texture: textureDataVoltaBanner,
    },
    voltaBannerDesktop: {
        image: voltaBannerDesktop,
        texture: textureDataVoltaBannerDesktop,
    },
    voltaMiniGame: {
        image: voltaMiniGame,
        texture: textureDataVoltaMiniGame,
    },
    logoCLB: {
        image: logoCLB,
        texture: textureDataLogoCLB,
    },
    leaderBoard: {
        image: leaderBoard,
        texture: textureDataLeaderBoard,
    },
};
